import { Pipe, PipeTransform } from '@angular/core';
import { DepartmentEstimate } from '@interfaces/DepartmentEstimate';

@Pipe({
  name: 'hoursBillable'
})
export class HoursBillablePipe implements PipeTransform {
  public transform(departmentEstimate: DepartmentEstimate): number {
    let totalHoursBillable = 0;

    for (const estimateLine of departmentEstimate.estimateLines) {
      for (const classificationLine of estimateLine.classificationLines) {
        totalHoursBillable += classificationLine.hours * classificationLine.rateBillable;
      }
    }

    return totalHoursBillable;
  }
}
